// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider__divider___3JwO8","vertical":"divider__vertical___vXBed","extra":"divider__extra___dAzqg"};